import axios from 'axios';
import env from '../../config';
import { LessonStatusUpdate } from '@opanuj/shared/types/api';
import { useMutation } from '@tanstack/react-query';

export type useLessonUpdateProps = {
	onSuccess: () => void
}

const useLessonStatusUpdate = ({onSuccess}: useLessonUpdateProps) => {
	return useMutation({
		mutationFn: (data: LessonStatusUpdate['body']) => {
			return axios.post(env.endpoints.lessonStatusUpdate, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			});
		},
		onSuccess
	})
};

export default useLessonStatusUpdate;
